import { useState } from 'react'
import './styles.scss'

import { MdEmail, MdSmartphone } from 'react-icons/md'

const Footer = () => {
    const [email,setEmail] = useState(false)
    const [number,setNumber] = useState(false)

    const handlerEmailClick = () => {
        setEmail(true)
        navigator.clipboard.writeText('fesosa.work@gmail.com')
        setTimeout(() => {
            setEmail(false);
        }, 3000);
    } 
    const handlerNumberClick = () => {
        setNumber(true)
        navigator.clipboard.writeText('(11)97156-1529')
        setTimeout(() => {
            setNumber(false);
        }, 3000);
    } 

    return (
        <section className="Footer">
            <div className='footer--left'>
                <h1>FeSosa</h1>
                <div className='links'>
                    <p onClick={handlerEmailClick}><MdEmail />{email?'Copiado':'Email'}</p>
                    <p onClick={handlerNumberClick}><MdSmartphone />{number?'Copiado':'Telefone'}</p>
                </div>
            </div>

            <div className='footer--center'>

            </div>

            <div className='footer-right'>
                <a href='/license'>Licenças</a>
            </div>
        </section>
    );
}
export default Footer